import { put, select } from 'redux-saga/effects';

import { snackbarModel } from '..';
import { NotificationItem } from '../reducer';

export function* removeNotification({ payload }: ReturnType<typeof snackbarModel.actions.removeNotificationAction>) {
  const notifications: NotificationItem[] = yield select(snackbarModel.selectors.selectNotifications);
  yield put(snackbarModel.actions.setNotifications(notifications.filter(i => i.id !== payload)));
}
